// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-box-default {
  display: flex;
  width: 237.65px;
  height: 80%;
  padding: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-items: center;
  border-radius: 12px;
  border: 1px solid var(--Basic-LineCard, #e9e9e9);
}
.default-text {
  display: flex;
  padding: 0 12px;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  top: 120px;
}

.infobox-title {
  color: var(--14bis-Medium, #16478e);
  text-align: center;
  font-family: Open Sans variable, Helvetica;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.infobox-smalltext {
  color: var(--14bis-Medium, #16478e);
  text-align: center;
  font-family: Open Sans variable, Helvetica;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.info-box {
  display: flex;
  width: 237.65px;
  height: 80%;
  padding: 12px;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  border: 1px solid var(--Basic-LineCard, #e9e9e9);
  gap: 25px;
}

.position {
  align-self: self-start;
  color: var(--Text-Primary, #171a1c);
  font-family: Open Sans variable, Helvetica;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
.instructions{
  display: inline-flex;
  align-self: self-start;
  align-items: center;
  width: 196px;
  gap: 10px;
  color: var(--Text-Secondary, #32383E);
  font-family: Open Sans variable, Helvetica;
  font-size: 12.522px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 6px;
}

.instructions-icon{
  width: 24px;
  height: 30px;
  aspect-ratio: 4/5;
}

.info-text {
  align-self: self-start;
  padding: 6px;
  gap: 10px;
  color: var(--Text-Primary, #171a1c);
  font-family: Open Sans variable, Helvetica;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
}

.icon-action{
  color: var(--brand-14bis-blue-medium);
  flex: 0 0 auto !important;

}
`, "",{"version":3,"sources":["webpack://./src/containers/FinalPackingPage/InfoBox.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gDAAgD;AAClD;AACA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;EACnC,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,SAAS;EACT,mCAAmC;EACnC,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;;AAE3B","sourcesContent":[".info-box-default {\n  display: flex;\n  width: 237.65px;\n  height: 80%;\n  padding: 12px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  align-items: center;\n  border-radius: 12px;\n  border: 1px solid var(--Basic-LineCard, #e9e9e9);\n}\n.default-text {\n  display: flex;\n  padding: 0 12px;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  align-self: stretch;\n  top: 120px;\n}\n\n.infobox-title {\n  color: var(--14bis-Medium, #16478e);\n  text-align: center;\n  font-family: Open Sans variable, Helvetica;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.infobox-smalltext {\n  color: var(--14bis-Medium, #16478e);\n  text-align: center;\n  font-family: Open Sans variable, Helvetica;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.info-box {\n  display: flex;\n  width: 237.65px;\n  height: 80%;\n  padding: 12px;\n  flex-direction: column;\n  align-items: center;\n  border-radius: 12px;\n  border: 1px solid var(--Basic-LineCard, #e9e9e9);\n  gap: 25px;\n}\n\n.position {\n  align-self: self-start;\n  color: var(--Text-Primary, #171a1c);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n}\n.instructions{\n  display: inline-flex;\n  align-self: self-start;\n  align-items: center;\n  width: 196px;\n  gap: 10px;\n  color: var(--Text-Secondary, #32383E);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 12.522px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  padding: 6px;\n}\n\n.instructions-icon{\n  width: 24px;\n  height: 30px;\n  aspect-ratio: 4/5;\n}\n\n.info-text {\n  align-self: self-start;\n  padding: 6px;\n  gap: 10px;\n  color: var(--Text-Primary, #171a1c);\n  font-family: Open Sans variable, Helvetica;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.icon-action{\n  color: var(--brand-14bis-blue-medium);\n  flex: 0 0 auto !important;\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
